

export const Url = {

    consumeParam(name: string) {

        const url = new URL(window.location.href);
        const value = url.searchParams.get(name);
        url.searchParams.delete(name);
        window.history.replaceState({}, '', url.toString());

        return value;
    }
}